import { NodeKind } from './nodes';
export const LibraryKind = {
    Rectangle: NodeKind.Rectangle,
    Text: NodeKind.Text,
    Image: NodeKind.Image,
    Video: NodeKind.Video,
    Ellipse: NodeKind.Ellipse,
    Button: NodeKind.Button,
    Widget: NodeKind.Widget,
    Feeds: 'feeds',
    Selection: 'selection',
    Any: 'any'
};
export var MediaLibraryMode;
(function (MediaLibraryMode) {
    MediaLibraryMode["list"] = "list";
    MediaLibraryMode["grid"] = "grid";
    MediaLibraryMode["preview"] = "preview";
})(MediaLibraryMode || (MediaLibraryMode = {}));
